import axios from 'axios'

export const getReturns = (params, config = {}) => {
  return axios.get('/finance/returns', { params, ...config })
}

export const getTotalReturns = (params) => {
  return axios.get('/finance/returns/totals', { params })
}

export const addReturn = (data) => {
  return axios.post('/finance/returns', data)
}

export const editReturn = (data) => {
  return axios.put(`/finance/returns/${data.id}`, data)
}

export const deleteOnAddReturnAttachment = (url) => {
  return axios.delete('/finance/returns/attachments', { data: { url } })
}

export const deleteOnEditReturnAttachment = (id, url) => {
  return axios.delete(`/finance/returns/${id}/attachments`, { data: { url } })
}

export const getReturn = (id, params, config = {}) => {
  return axios.get(`/finance/returns/${id}`, { params, ...config })
}

export const deleteReturn = (id) => {
  return axios.delete(`/finance/returns/${id}`)
}

export const getReturnLog = ({ id, params } = {}) => {
  return axios.get(`/finance/returns/${id}/logs`, { params })
}

export const approveReturn = (id) => {
  return axios.post(`/finance/returns/${id}/approve`)
}

export const rejectReturn = ({ id, data }) => {
  return axios.post(`/finance/returns/${id}/reject`, data)
}

export const revertApprovalReturn = (id) => {
  return axios.post(`/finance/returns/${id}/revert`)
}

export const inputMassDeleteReturn = (data) => {
  return axios.post('/finance/returns/inputMassDelete', data)
}

export const executeMassDeleteReturn = (data) => {
  return axios.delete('/finance/returns/executeMassDelete', { data })
}
